module.exports = __webpack_public_path__ + "static/media/watchlist.2028f125.png";